/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { SvgIModelJs } from "components/icons/SvgIModeljs";
import React from "react";
import { useController } from "react-hook-form";
import { SvgCamera, SvgRemove } from "@itwin/itwinui-icons-react";
import { Button, FileUpload, FileUploadTemplate, IconButton, Text } from "@itwin/itwinui-react";
import { FormField } from "../FormField";
import styles from "./ThumbnailUpload.module.css";

interface ThumbnailUploadProps extends FormField {
}

export const ThumbnailUpload = ({ name, control }: ThumbnailUploadProps) => {

  const {
    field,
    formState
  } = useController({
    name,
    control
  });

  const onClearThumbnail = () => {
    field.onChange(null);
  };

  const onFileDropped = (files: FileList) => {
    const file = files.item(0);
    if (file && file.type.includes("image")) {
      field.onChange(URL.createObjectURL(file));
    }
  };

  const onFileAdded: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const files = e.target.files;
    if (files) {
      onFileDropped(files);
    }
  };

  return (
    <div className={styles.container}>
      <div className={["iui-tile", styles.tile].join(" ")}>
        <div className="iui-tile-thumbnail">
          {field.value ? <div className="iui-tile-thumbnail-picture" style={{ backgroundImage: `url("${field.value}")` }}></div> : <SvgIModelJs className={styles.noThumbnail} />}
          {field.value && <div className={styles.thumbnailRemoveBtn}>
            <IconButton styleType="default" size="large" disabled={formState.isSubmitting} onClick={onClearThumbnail}>
              <SvgRemove />
            </IconButton>
          </div>}
        </div>
      </div>
      <FileUpload onFileDropped={onFileDropped} className={styles.uploadArea} data-testid="atp-upload-thumbnail">
        <FileUploadTemplate acceptMultiple={false} acceptType={"image/*"} onChange={onFileAdded}
          subtitle={<Text isMuted>or drag and drop it</Text>}
        ></FileUploadTemplate>
      </FileUpload>
      <Button startIcon={<SvgCamera />} styleType="default" className={styles.captureBtn} disabled={true} >Capture from Preview</Button>
    </div>
  );
};
